<template>
	<div class="content">
		<div class="row animated fadeIn">
			<div class="col-12">
				<Alert :type="alertType" :message="alertMessage" v-if="alertShow === true" />
				<div class="card" v-if="asyncDone === false">
					<!-- Show the loader when async operation is going on -->
					<div class="loader"></div>
				</div>
			</div>
			<div class="col-12" v-if="asyncDone">
				<div class="card mb-0">
					<div class="card-header mt-3">
						<h4 class="card-title ml-4 d-inline-block">#{{ ticket.ticket_number }} - {{ ticket.subject }}</h4>
						<span class="badge badge-pill d-inline-block float-right mr-4 mt-3" :class="getTicketStatusClass(ticket.status)">{{ ticket.status }}</span>
					</div>
					<div class="card-body pl-5 pr-5">
						<p class="pre-wrap" v-html="formattedText(ticket.body)"></p>
						<p class="text-secondary text-right" style="font-size: 12px;"><span class="text-info">Opened By:</span> {{ ticket.name }} on {{ ticket.date }}</p>
					</div>
				</div>
				<div class="card card-timeline card-plain mb-0">
					<div class="card-body">
						<ul class="timeline timeline-simple mb-0">
							<li class="timeline-inverted" v-for="(reply, index) in replies" :key="index">
								<div class="timeline-badge" style="border: none;">
									<img :src="`https://www.gravatar.com/avatar/${reply.gravatar}?s=50`" width="50px" height="50px" />
								</div>
								<div class="timeline-panel">
									<div class="timeline-heading">
										<i class="fa fa-reply mr-1" aria-hidden="true"></i> Reply By: <span class="badge badge-pill ml-2" :class="{ 'badge-info' : (reply.type === 'Client' || reply.type === 'Email'), 'badge-success': !(reply.type === 'Client' || reply.type === 'Email') }">{{ reply.name }}</span>
									</div>
									<div class="timeline-body">
										<p class="pre-wrap" v-html="formattedText(reply.body)"></p>
									</div>
                  <a  href="javascript:void(0);" class="pull-right" v-for="(attachment, attach_index) of attachments[reply.id]" :disabled="loading === attachment.id" :key="attach_index" @click="downloadAttachment(attachment)">
                    <div class="loader" v-if="loading === attachment.id" style="width: 30px;height: 30px; margin: 0 auto !important;"></div>
                    <span v-else>Attachment <i class="fa fa-paperclip"/></span>
                  </a>
									<h6>
										<i class="fa fa-clock-o mr-2"></i> {{ reply.date }}
									</h6>
								</div>
							</li>
						</ul>
					</div>
				</div>

				<ReplyBox :ticket="ticket" :clientId="clientID" ticketFrom="owner" />
				<div class="card">
					<div class="card-body p-5">
						<h4 class="mt-0 mb-0 text-center">You can reply to this ticket directly from your email.</h4>
						<a :href="`mailto:support@bigscoots.com?subject=Re: [Ticket #${ticket.ticket_number}] ${ticket.subject}`" class="btn btn-primary btn-lg center">Send Email</a>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import AES from 'crypto-js/aes';
import CryptoJSCore from 'crypto-js/core';
import autoLink from 'autolink.js';
import { functions } from '@/firebase/init'

export default {
	name: "viewTicketPage",
	props: {
		id: String
	},
  components: {
	Alert: () =>
	import(/* webpackChunkName: "alert" */ "../../../../components/Alerts.vue"),
	ReplyBox: () =>
			import(/* webpackChunkName: "migrationIntro" */ "../../../../components/Helps/TicketReplyBox.vue"),
	},
	data() {
		return {
      loading: null,
			ticketID: '',
			ticket: {},
			replies: [],
      attachments: {}
		}
	},
  computed: {
		clientID() {
			return this.$store.getters.getCustomerID
		},
	asyncDone() {
	return this.$store.getters["async/state"];
	},
	alertType() {
	return this.$store.getters["alert/type"];
	},
	alertMessage() {
	return this.$store.getters["alert/message"];
	},
	alertShow() {
	return this.$store.getters["alert/show"];
		},
		aesSecret() {
	return this.$store.getters["crypto/aesSecret"];
		},
	userEmailHash() {
		return this.$store.getters.emailHashGravatar;
	}
	},
	methods: {
    async downloadAttachment (attachment) {
      this.loading = attachment.id;
      try {
        const response = await this.$http.post('host-bill/download-attachment', {
          id: attachment.id,
          grant_type: 'token'
        });
        const linkSource = `data:application/pdf;base64,${response.data.base64}`;
        const downloadLink = document.createElement("a");
        const fileName = 'attachment.' + response.data.type;

        downloadLink.href = linkSource;
        downloadLink.download = fileName;
        downloadLink.click();
        this.loading = null;
      } catch (e) {
        this.loading = null;

        await this.$store.dispatch("alert/update", {
          type: "error",
          message: e.message,
          show: true
        })
        this.addLog({
          message: "Error: Download Attachment, Message:" + e.message,
          level:  "error"
        })
        setTimeout(() => {
          this.$store.dispatch("alert/showUpdate", { show: false })
        }, 5000)
      }
    },
		ticketIDParse(id) {
			if(typeof id === 'undefined') {
				this.ticketID = ''
			} else {
				const bytes = AES.decrypt( id, this.aesSecret )
				this.ticketID = parseInt( bytes.toString(CryptoJSCore.enc.Utf8) )
			}
		},
		getTicketStatusClass(status) {
			return {
				"badge-success": status === "Answered",
				"badge-warning": status === "In-Progress",
				"badge-info": (status === "Open" || status === "Sales Followup"),
				"badge-primary": (status === "Client-Reply" || status === "Waiting on Billing"),
				"badge-default": status === "Closed"
			}
		},
		formattedText(text) {
      if (text) {
        return autoLink(text, {
          // default options:
          email: true,
          image: true,
          linkAttr: {
            'target': '_blank',
            'rel': 'nofollow'
          },
          // \n to <br/>
          br: true
        })
      }
      return ''
		},
		async fetchTicketDetails() {
			await this.$store.dispatch("async/stateUpdate", {state: false})

      try {
        const response = await this.$http.post('host-bill/fetch-ticket-details', {
          ticketID: this.ticketID,
          grant_type: 'token'
        });
        await this.$store.dispatch("async/stateUpdate", {state: true})
        console.log(response.data)
        this.ticket = {
          ...response.data.ticket
        }
        let ticketReplies = response.data.replies;

        if(!Array.isArray(ticketReplies)) {
          ticketReplies = Object.values(response.data.replies)
        }

        this.replies = [
          ...ticketReplies
        ]
        this.attachments = response.data.attachments
      } catch (e) {
        await this.$store.dispatch("async/stateUpdate", {state: true})

        await this.$store.dispatch("alert/update", {
          type: "error",
          message: e.message,
          show: true
        })

        this.addLog({
          message: "Error: View Ticket, Message:" + e.message,
          level:  "error"
        })

        setTimeout(() => {
          this.$store.dispatch("alert/showUpdate", { show: false })
        }, 5000)
      }
		}
	},
	created() {
		this.ticketIDParse(this.id)
		this.fetchTicketDetails()
	}
};
</script>

<style>
.pre-wrap {
	white-space: pre-wrap;
  word-wrap: break-word;
  font-family: inherit;
}
</style>
